import { useContext } from "react";
import { NotificationContext } from "../contexts/notificationContext";

export default () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error("Wrap your app in NotificationProvider");
  }

  return context;
};
